export default __webpack_public_path__ + "static/media/ahmadmahmood.824565f2.jpg";